import {
  InvestmentClient,
  InvestmentsActionTypes,
  LastPerformance,
  InvestmentOrder,
  Fund,
  InvestmentParams,
  InvestmentOrderWithActivityData
} from './types'

export const setInvestmentsLoading = () => ({
  type: InvestmentsActionTypes.SET_LOADING
})

export const dismissInvestmentsLoading = () => ({
  type: InvestmentsActionTypes.DISMISS_LOADING
})

export const createInvestmentsAccount = (data: any) => ({
  type: InvestmentsActionTypes.CREATE_ACCOUNT,
  payload: data
})

export const getInvestmentsOperations = (data: any) => ({
  type: InvestmentsActionTypes.GET_OPERATIONS,
  payload: data
})

export const setInvestmentsBalance = (data: number | string) => ({
  type: InvestmentsActionTypes.SET_INVESTMENT_BALANCE,
  payload: data
})

export const setPerformance = (data: any) => ({
  type: InvestmentsActionTypes.SET_PERFORMANCE,
  payload: data
})

export const getTutorialCompletionPending = () => ({
  type: InvestmentsActionTypes.GET_TUTORIAL_COMPLETION_PENDING
})

export const getTutorialCompletionFulfilled = (data: boolean) => ({
  type: InvestmentsActionTypes.GET_TUTORIAL_COMPLETION_FULFILLED,
  payload: data
})

export const getTutorialCompletionRejected = () => ({
  type: InvestmentsActionTypes.GET_TUTORIAL_COMPLETION_REJECTED
})

export const getIsTutorialCompletedPending = () => ({
  type: InvestmentsActionTypes.GET_IS_TUTORIAL_COMPLETED_PENDING
})

export const getIsTutorialCompletedFulfilled = (data: boolean) => ({
  type: InvestmentsActionTypes.GET_IS_TUTORIAL_COMPLETED_FULFILLED,
  payload: data
})

export const getIsTutorialCompletedRejected = () => ({
  type: InvestmentsActionTypes.GET_IS_TUTORIAL_COMPLETED_REJECTED
})

export const getInvestmentClientPending = () => ({
  type: InvestmentsActionTypes.GET_INVESTMENT_CLIENT_PENDING
})

export const getInvestmentClientFulfilled = (data: InvestmentClient) => ({
  type: InvestmentsActionTypes.GET_INVESTMENT_CLIENT_FULFILLED,
  payload: data
})

export const getInvestmentClientRejected = () => ({
  type: InvestmentsActionTypes.GET_INVESTMENT_CLIENT_REJECTED
})

export const setSubscriptionPending = () => ({
  type: InvestmentsActionTypes.SET_SUBSCRIPTION_PENDING
})

export const setSubscriptionFulfilled = () => ({
  type: InvestmentsActionTypes.SET_SUBSCRIPTION_FULFILLED
})

export const setSubscriptionRejected = () => ({
  type: InvestmentsActionTypes.SET_SUBSCRIPTION_REJECTED
})

export const setRescuePending = () => ({
  type: InvestmentsActionTypes.SET_RESCUE_PENDING
})

export const setRescueFulfilled = () => ({
  type: InvestmentsActionTypes.SET_RESCUE_FULFILLED
})

export const setRescueRejected = () => ({
  type: InvestmentsActionTypes.SET_RESCUE_REJECTED
})

export const getHoldingAccountPending = () => ({
  type: InvestmentsActionTypes.GET_HOLDING_ACCOUNT_PENDING
})

export const getHoldingAccountFulfilled = (amount: string) => ({
  type: InvestmentsActionTypes.GET_HOLDING_ACCOUNT_FULFILLED,
  payload: amount
})

export const getHoldingAccountRejected = () => ({
  type: InvestmentsActionTypes.GET_HOLDING_ACCOUNT_REJECTED
})

export const getLastPerformancePending = () => ({
  type: InvestmentsActionTypes.GET_LAST_PERFORMANCE_PENDING
})

export const getLastPerformanceFulfilled = (data: LastPerformance) => ({
  type: InvestmentsActionTypes.GET_LAST_PERFORMANCE_FULFILLED,
  payload: data
})

export const getLastPerformanceRejected = () => ({
  type: InvestmentsActionTypes.GET_LAST_PERFORMANCE_REJECTED
})

export const getOrdersPending = () => ({
  type: InvestmentsActionTypes.GET_ORDERS_PENDING
})

export const getOrdersFulfilled = (data: InvestmentOrder[]) => ({
  type: InvestmentsActionTypes.GET_ORDERS_FULFILLED,
  payload: data
})

export const getOrdersRejected = () => ({
  type: InvestmentsActionTypes.GET_ORDERS_REJECTED
})

export const getFundPending = () => ({
  type: InvestmentsActionTypes.GET_FUND_PENDING
})

export const getFundFulfilled = (data: Fund) => ({
  type: InvestmentsActionTypes.GET_FUND_FULFILLED,
  payload: data
})

export const getFundRejected = () => ({
  type: InvestmentsActionTypes.GET_FUND_REJECTED
})

export const getInvestmentParamsPending = () => ({
  type: InvestmentsActionTypes.GET_INVESTMENT_PARAMS_PENDING
})

export const getInvestmentParamsFulfilled = (data: InvestmentParams) => ({
  type: InvestmentsActionTypes.GET_INVESTMENT_PARAMS_FULFILLED,
  payload: data
})

export const getInvestmentParamsRejected = () => ({
  type: InvestmentsActionTypes.GET_INVESTMENT_PARAMS_REJECTED
})

export const setCancelInvestmentOrderPending = () => ({
  type: InvestmentsActionTypes.SET_CANCEL_INVESTMENT_ORDER_PENDING
})

export const setCancelInvestmentOrderFulfilled = (data: InvestmentOrder) => ({
  type: InvestmentsActionTypes.SET_CANCEL_INVESTMENT_ORDER_FULFILLED,
  payload: data
})

export const setCancelInvestmentOrderRejected = () => ({
  type: InvestmentsActionTypes.SET_CANCEL_INVESTMENT_ORDER_REJECTED
})

export const selectInvestmentOrder = (
  values: InvestmentOrderWithActivityData
) => ({
  type: InvestmentsActionTypes.SET_SELECT_INVESTMENT_ORDER,
  payload: values
})
